import { VideoSubject } from "@/types/models/UnlevelledContent.interface";
import DefaultNoAccessSvg from "./DefaultNoAccessSvg";
import GeniusNoAccessELASvg from "./GeniusNoAccessELASvg";
import GeniusNoAccessMathSvg from "./GeniusNoAccessMathSvg";
import GeniusNoAccessScienceSvg from "./GeniusNoAccessScienceSvg";
import { Banner, constants } from "./sharedImports";

const coreBlue25 = constants.colors.ui.core[25];

const white100 = constants.colors.ui.white["100"];

const fgProfileDark = Banner.foregroundProfiles.dark;

export default ({
  whiteBgColor,
  subject,
}: {
  whiteBgColor?: boolean;
  subject?: string | null | undefined;
}) => {
  let svg = DefaultNoAccessSvg;

  if (subject === VideoSubject.LANGUAGE_ARTS) {
    svg = GeniusNoAccessELASvg;
  } else if (subject === VideoSubject.MATHEMATICS) {
    svg = GeniusNoAccessMathSvg;
  } else if (subject === VideoSubject.SCIENCE) {
    svg = GeniusNoAccessScienceSvg;
  }

  return {
    colors: {
      primary: whiteBgColor ? white100 : coreBlue25,
      foregroundProfile: fgProfileDark,
    },
    SvgComponent: svg,
  };
};
